import { actionsDefinition } from '../../actions/actionsDefinition';

export const httpCallStartAction = () => ({
    type: actionsDefinition.http.HTTP_CALL_START,
});

export const httpCallEndAction = () => ({
    type: actionsDefinition.http.HTTP_CALL_END,
});
